import React from 'react'

function ShowByTitle() {
  return (
    <div>
    ShowByTitle
    </div>
  )
}

export default ShowByTitle
